import React from "react";

/**
 * AviIcon — icône du module AVI.
 *
 * Spec rev168 (2026-02) : 3 barres sémantiques par sous-type avec
 * effet de pic central (Validation plus haute que Accusé / Information).
 *   • Barre 1 « Accusé »      : #E0A55A (orange), 10 × 18 px
 *   • Barre 2 « Validation »  : #5b5fc7 (violet MS Teams, spec iter87 Feb 2026),
 *                              10 × 25 px (pic)
 *   • Barre 3 « Information » : #2A9A7A (vert), 10 × 18 px
 *   • border-radius : 5 px
 *   • Gap entre barres : 5 px
 *   → Largeur totale = 3 × 10 + 2 × 5 = 40 px ; hauteur = 25 px.
 *
 * La prop `size` contrôle la LARGEUR totale (défaut 40 px). L'aspect
 * 40:25 est préservé via un viewBox natif — le composant se scale sans
 * déformation. Les barres 1 et 3 sont centrées verticalement (y = 3.5)
 * dans le viewBox pour donner l'effet de pic central sur Validation.
 */
export default function AviIcon({ size = 40, ...rest }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={(size * 25) / 40}
      viewBox="0 0 40 25"
      fill="none"
      {...rest}
    >
      <rect x="0"  y="3.5" width="10" height="18" rx="5" fill="#E0A55A" />
      <rect x="15" y="0"   width="10" height="25" rx="5" fill="#5b5fc7" />
      <rect x="30" y="3.5" width="10" height="18" rx="5" fill="#2A9A7A" />
    </svg>
  );
}
